/**
 * Maps visible page titles (tab bar / headings) to the lowercase phrase used after "Loading ".
 */
const LOADING_PHRASE_EXCEPTIONS: Record<string, string> = {
  Motivation: "motivation data",
  Fitness: "fitness data",
  Compare: "player data",
  Financial: "financial data",
  News: "news data",
  Social: "Instagram data",
  Fan: "fan portal",
}

export function loadingPhraseFromNavTitle(pageTitle: string): string {
  const t = pageTitle.trim()
  if (LOADING_PHRASE_EXCEPTIONS[t]) return LOADING_PHRASE_EXCEPTIONS[t]
  return t.toLowerCase()
}

export function loadingMessageForPage(pageTitle: string): string {
  return `Loading ${loadingPhraseFromNavTitle(pageTitle)}...`
}
